module.exports = __webpack_public_path__ + "static/media/delivery.cca9d864.svg";